export default __webpack_public_path__ + "static/media/penllagen_docs.09c6bd9e.zip";